<template>
  <v-container id="page-approvement">
    <div class="page-title">{{ $route.name }}</div>

    <v-row justify="end" cols="12" md="6" sm="12" class="mr-2">
      <v-menu
        v-model="startMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 200px">
            <v-text-field
              v-model="startDate"
              label="시작일"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </div>
        </template>
        <c-date-picker
          v-model="startDate"
          @input="startMenu = false"
          firstDayOfWeek="1"
          :selectedDate="startDate"
          locale="ko-kr"
        ></c-date-picker>
      </v-menu>
      <v-menu
        v-model="endMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 200px">
            <v-text-field
              v-model="endDate"
              label="종료일"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </div>
        </template>
        <c-date-picker
          v-model="endDate"
          @input="endMenu = false"
          firstDayOfWeek="1"
          :selectedDate="endDate"
          locale="ko-kr"
        ></c-date-picker>
      </v-menu>
    </v-row>
    <v-row justify="end" cols="12" md="6" sm="12" class="mr-2">
      <v-menu
        v-model="typeMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="200px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 200px">
            <v-select
              v-model="searchType"
              :items="searchTypeList"
              label="검색타입"
              placeholder="신청 회원, 담당자"
              item-text="label"
              item-value="value"
            ></v-select>
          </div>
        </template>
      </v-menu>
      <v-menu
        v-model="keywordMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="200px"
      >
        <template v-slot:activator="{ on }">
          <div style="width: 200px">
            <v-text-field
              v-model="keyword"
              label="검색어"
              :placeholder="keywordPlaceholder"
              prepend-icon="search"
              v-on="on"
              maxlength="32"
              @keyup="onSearch"
            ></v-text-field>
          </div>
        </template>
      </v-menu>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <c-card outlined>
          <v-row>
            <v-col cols="12" md="5" sm="12">
              <v-row>
                <v-col cols="12" md="3" sm="12">
                  <span class="title font-weight-bold ml-3 mr-5">전체</span>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <span class="subtitle font-weight-bold mr-3">대기</span>
                  <span
                    @click="onFilterType('receipt')"
                    class="font-weight-bold mr-5 red--text"
                    style="cursor: pointer"
                    >{{ this.counts.totalReceipt }}</span
                  >
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <span class="subtitle font-weight-bold mr-3">승인</span>
                  <span
                    @click="onFilterType('approve')"
                    class="font-weight-bold mr-5"
                    style="cursor: pointer"
                    >{{ this.counts.totalApprove }}</span
                  >
                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <span class="subtitle font-weight-bold mr-3">반려</span>
                  <span
                    @click="onFilterType('decline')"
                    class="font-weight-bold mr-5"
                    style="cursor: pointer"
                    >{{ this.counts.totalDecline }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" sm="12">
              <c-card outlined>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <span class="title font-weight-bold">바우처 자격증빙</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" sm="4">
                    <span class="subtitle font-weight-bold mr-3">대기</span>
                    <span class="font-weight-bold red--text">{{
                      this.counts.apCustomerReceipt
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <span class="subtitle font-weight-bold mr-3">승인</span>
                    <span class="font-weight-bold">{{
                      this.counts.apCustomerApprove
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <span class="subtitle font-weight-bold mr-3">반려</span>
                    <span class="font-weight-bold">{{
                      this.counts.apCustomerDecline
                    }}</span>
                  </v-col>
                </v-row>
              </c-card>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <c-card outlined>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <span class="title font-weight-bold">그룹 회원 추가</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" sm="4">
                    <span class="subtitle font-weight-bold mr-3">대기</span>
                    <span class="font-weight-bold red--text">{{
                      this.counts.apGroupReceipt
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <span class="subtitle font-weight-bold mr-3">승인</span>
                    <span class="font-weight-bold">{{
                      this.counts.apGroupApprove
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <span class="subtitle font-weight-bold mr-3">반려</span>
                    <span class="font-weight-bold">{{
                      this.counts.apGroupDecline
                    }}</span>
                  </v-col>
                </v-row>
              </c-card>
            </v-col>
            <v-col cols="12" md="4" sm="12">
              <c-card outlined>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <span class="title font-weight-bold">바우처 사용</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <span class="subtitle font-weight-bold mr-2">미제출</span>
                    <span class="font-weight-bold red--text mr-2">{{
                      this.counts.apVoucherUnsubmission
                    }}</span>
                    <span class="subtitle font-weight-bold mr-2">대기</span>
                    <span class="font-weight-bold red--text mr-2">{{
                      this.counts.apVoucherReceipt
                    }}</span>
                    <span class="subtitle font-weight-bold mr-2">승인</span>
                    <span class="font-weight-bold mr-2">{{
                      this.counts.apVoucherApprove
                    }}</span>
                    <span class="subtitle font-weight-bold mr-2">반려</span>
                    <span class="font-weight-bold">{{
                      this.counts.apVoucherDecline
                    }}</span>
                  </v-col>
                </v-row>
              </c-card>
            </v-col>
          </v-row>
        </c-card>
      </v-col>
    </v-row>
    <c-table
      :headers="tableHeader"
      :items="approveList"
      multi-sort
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #type="{item}">
        {{ item.type }}
      </template>
      <template #created="{item}">
        {{ item.created ? $func.dateTimeToString(item.created) : "-" }}
      </template>
      <template #approvementDate="{item}">
        {{
          item.approvementDate
            ? $func.dateTimeToString(item.approvementDate)
            : "-"
        }}
      </template>
      <template #adminName="{item}">
        {{ item.adminName ? item.adminName : "-" }}
      </template>

      <template #state="{item}">
        <span :class="setColor(item.approvementProcess)">
          {{ item.state }}
        </span>
      </template>
      <template #detail="{item}">
        <c-btn icon iconName="search" @click="onMoveDetail(item)" />
      </template>
    </c-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      startDate: this.$func.curDateStringAddDays(-7),
      endDate: this.$func.curDateString(),
      counts: {
        apCustomerReceipt: 0,
        apCustomerApprove: 0,
        apCustomerDecline: 0,
        apGroupReceipt: 0,
        apGroupApprove: 0,
        apGroupDecline: 0,
        apVoucherReceipt: 0,
        apVoucherApprove: 0,
        apVoucherDecline: 0,
        apVoucherUnsubmission: 0,
        totalReceipt: 0,
        totalApprove: 0,
        totalDecline: 0,
      },
      keyword: "",
      startMenu: false,
      endMenu: false,
      typeMenu: false,
      keywordMenu: false,
      tableHeader: [
        {
          text: "신청 회원",
          value: "customerName",
          align: "center",
          sortable: true,
        },
        {
          text: "신청 유형",
          value: "type",
          align: "center",
          sortable: true,
        },
        {
          text: "신청 일시",
          value: "requestDate",
          align: "center",
          sortable: true,
        },
        {
          text: "처리 일시",
          value: "approvementDate",
          align: "center",
          sortable: true,
        },
        {
          text: "담당자",
          value: "adminName",
          align: "center",
          sortable: true,
        },
        {
          text: "진행 상황",
          value: "state",
          align: "center",
          sortable: true,
        },
        {
          text: "상세보기",
          value: "detail",
          align: "center",
          sortable: false,
        },
      ],
      approveList: [],
      tableData: [],
      filteringType: "",
      searchType: "CUSTOMER_NAME",
      searchTypeList: [
        {
          label: "신청 회원",
          value: "CUSTOMER_NAME",
        },
        {
          label: "담당자",
          value: "ADMIN_NAME",
        },
      ],
      pagination: {
        page: 1,
        size: 10,
        sort: "",
      },
      totalElements: 0,
    };
  },
  watch: {
    startDate: function() {
      this.reqApproveList();
    },
    endDate: function() {
      this.reqApproveList();
    },
  },
  activated() {
    this.reqApproveList();
  },
  computed: {
    keywordPlaceholder() {
      return this.searchType === "CUSTOMER_NAME" ? "신청 회원" : "담당자";
    },
  },
  methods: {
    async reqApproveList() {
      try {
        const res = await this.$api.getApprovementBetween(
          this.startDate,
          this.endDate,
          {
            ...this.pagination,
            searchType: this.searchType,
            searchKeyword: this.keyword,
            filteringType: this.filteringType,
          }
        );
        this.counts = {
          apCustomerReceipt: 0,
          apCustomerApprove: 0,
          apCustomerDecline: 0,
          apGroupReceipt: 0,
          apGroupApprove: 0,
          apGroupDecline: 0,
          apVoucherReceipt: 0,
          apVoucherApprove: 0,
          apVoucherDecline: 0,
          apVoucherUnsubmission: 0,
          totalReceipt: 0,
          totalApprove: 0,
          totalDecline: 0,
        };

        this.approveList = res.data.list.content.map((item, idx) => {
          item.apprConfigValue = item.type.configValue;
          item.type = item.type.configName;
          item.state = item.state.configName;
          return item;
        });
        this.totalElements = res.data.list.totalElements;

        res.data.stat.forEach((v) => {
          if (v.approvementType.configName === "바우처 자격증빙") {
            this.counts.apCustomerReceipt =
              this.counts.apCustomerReceipt + v.receipt;
            this.counts.apCustomerApprove =
              this.counts.apCustomerApprove + v.approve;
            this.counts.apCustomerDecline =
              this.counts.apCustomerDecline + v.decline;
          }
          if (v.approvementType.configName === "회원유형변경") {
            this.counts.apCustomerReceipt =
              this.counts.apCustomerReceipt + v.receipt;
            this.counts.apCustomerApprove =
              this.counts.apCustomerApprove + v.approve;
            this.counts.apCustomerDecline =
              this.counts.apCustomerDecline + v.decline;
          }
          if (v.approvementType.configName === "바우처사용") {
            this.counts.apVoucherReceipt = v.receipt;
            this.counts.apVoucherApprove = v.approve;
            this.counts.apVoucherDecline = v.decline;
            this.counts.apVoucherUnsubmission = v.unsubmission;
          }
          if (v.approvementType.configName === "그룹가입신청") {
            this.counts.apGroupReceipt = v.receipt;
            this.counts.apGroupApprove = v.approve;
            this.counts.apGroupDecline = v.decline;
          }
        });

        this.counts.totalReceipt =
          this.counts.apCustomerReceipt +
          this.counts.apGroupReceipt +
          this.counts.apVoucherReceipt;
        this.counts.totalApprove =
          this.counts.apCustomerApprove +
          this.counts.apGroupApprove +
          this.counts.apVoucherApprove;
        this.counts.totalDecline =
          this.counts.apCustomerDecline +
          this.counts.apGroupDecline +
          this.counts.apVoucherDecline;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqApproveList" });
      }
    },
    setColor(data) {
      if (data === "미제출" || data === "반려") {
        return "red--text";
      } else {
        return "grey--text";
      }
    },
    onMoveDetail(item) {
      this.$router.push(`/approvement/${item.id}`);
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqApproveList();
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqApproveList();
      } else {
        return;
      }
    },
    onFilterType(type) {
      this.filteringType = type;
      this.reqApproveList();
    },
  },
};
</script>

<style scoped></style>
